<template>
  <div class="edit-table">
    <div class="padding_50">
      <vxe-toolbar v-if="!disabled">
        <template v-slot:buttons>
          <vxe-button @click="showSignModal()" >添加地址</vxe-button>
        </template>
      </vxe-toolbar>
      <vxe-table :data="addressList">
        <vxe-table-column min-width="100" field="address" title="地点">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="province" title="省">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="city" title="市">
        </vxe-table-column>
        <vxe-table-column min-width="100" field="district" title="区">
        </vxe-table-column>
        <vxe-table-column
          title="操作"
          width="100"
          show-overflow
          v-if="!disabled"
          key="操作"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="deletRow(row, rowIndex)">删除</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <!-- 打卡地点弹窗 -->
    <MapSign :visible.sync="signModalVisible" @submit="signModalSubmit"></MapSign>
  </div>
</template>

<script>
import MapSign from './map_sign.vue';

export default {
  name: 'configProducts',
  components: {
    MapSign,
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  watch: {
    value: {
      handler(val) {
        this.addressList = val || [];
      },
      deep: true,
    },
    disabled(val) {
      console.log('🚀 ~ disabled ~ val:', val);
    },
  },
  data() {
    return {
      addressList: [], // 当前关联费用科目数据
      signModalVisible: false, // 打卡地点弹窗显隐
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 删除行
    deletRow(row, rowIndex) {
      console.log(this.addressList);
      this.$confirm('您确定要删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log(this.addressList, 'addressList');
        this.addressList.splice(rowIndex, 1);
        this.$emit('input', this.addressList);
      });
    },
    deleteTable() {
      this.addressList = [];
      this.$emit('input', []);
    },
    // 打开点击弹窗地图
    showSignModal() {
      this.signModalVisible = true;
    },
    /** @desc 打卡地点弹窗提交按钮 */
    signModalSubmit(val) {
      console.log(val, 'val');
      const obj = {
        ...val,
        address: val.title,
        latitude: val.lat,
        location: val.lng,
      };
      this.addressList = this.addressList.concat([obj]);
      this.$emit('input', this.addressList);
    },
  },
};
</script>

<style lang="less" scoped>
  .edit-table {
    padding-left: 50px;
    margin-left: 0 !important;
  }
</style>
